package com.vizio.redwolf.auth.model

data class UserDetailsRequestInfo(val accessToken: String)